var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"kb_breadcrumb__item"},[_c('span',{ref:"link",class:['kb_breadcrumb__inner', _vm.to ? 'is-link' : ''],attrs:{"role":"link"}},[_vm._t("default")],2),(!_vm.isLastItem)?_c('span',{staticClass:"kb_breadcrumb__separator",attrs:{"role":"presentation"}},[_vm._v(_vm._s(_vm.separator))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }